import { Route } from '@angular/router';
import { MapModalComponent } from '../../pages/map-modal/map-modal.component';
import { ProductListModalComponent } from './components/product-list-modal/product-list-modal.component';
import { InsuranceUpsellingComponent } from './components/insurance-upselling/insurance-upselling.component';

export const routes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./product-selection.component').then(c => c.ProductSelectionComponent),
    data: { hideFooter: true }
  },
  {
    path: 'insurance',
    component: InsuranceUpsellingComponent,
    outlet: 'modal',
    data: { skipRouteLocalization: true }
  },
  {
    path: 'map',
    component: MapModalComponent,
    outlet: 'modal',
    data: { skipRouteLocalization: true, mapType: 'single' }
  },
  {
    path: 'map/:shopId',
    component: MapModalComponent,
    outlet: 'modal',
    data: { skipRouteLocalization: true, mapType: 'single' }
  },
  {
    path: 'person/:personIndex',
    component: ProductListModalComponent,
    outlet: 'modal',
    data: { skipRouteLocalization: true },
    children: [
      {
        path: ':productId',
        loadComponent: () =>
          import('./components/model-modal/model-modal.component').then(c => c.ModelModalComponent),
        outlet: 'sideBar',
        data: { skipRouteLocalization: true, mobile: true }
      },
      {
        path: ':productId/:modelId',
        loadComponent: () =>
          import('./components/model-modal/model-modal.component').then(c => c.ModelModalComponent),
        outlet: 'sideBar',
        data: { skipRouteLocalization: true, mobile: true }
      }
    ]
  },
  {
    path: ':productId',
    loadComponent: () =>
      import('./components/model-modal/model-modal.component').then(c => c.ModelModalComponent),
    outlet: 'sideBar',
    data: { skipRouteLocalization: true, mobile: false }
  },
  {
    path: ':productId/:modelId',
    loadComponent: () =>
      import('./components/model-modal/model-modal.component').then(c => c.ModelModalComponent),
    outlet: 'sideBar',
    data: { skipRouteLocalization: true, mobile: false }
  },
  {
    // some product route not found? redirect to main product route
    path: '**',
    redirectTo: ''
  }
];
